import React from 'react'

import { faClock, faTrashAlt } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, CircularProgress, Typography, styled } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { NonDismissibleDialog } from '@scoir/modals'
import { connect } from 'react-redux'

import api from 'common/api'
import { actions as snactions } from 'store/snackbar'
import { actions as userActions } from 'store/user'

const MINIMUM_REVOKE_RESOLVE_TIME_MS = 1000

const DangerButton = styled(Button)(({ theme }) => ({
  color: theme.palette.error.main,
}))

type Props = {
  onComplete: () => void
  fetchUser: () => void
  onAddSnack: (message: string) => void
}
type State = {
  open: boolean
  loading: boolean
}

export class Disconnect extends React.Component<Props, State> {
  state: State = {
    open: false,
    loading: false,
  }
  disconnect() {
    this.setState({ loading: true })
    const floor = new Promise((resolve) => setTimeout(resolve, MINIMUM_REVOKE_RESOLVE_TIME_MS))
    api
      .put(`/api/oauth2/calendar/revoke`)
      .then(() =>
        floor.then(() => {
          this.setState({ open: false, loading: false })
          this.props.fetchUser()
          this.props.onComplete()
        }),
      )
      .catch(() =>
        floor.then(() => {
          this.setState({ open: false, loading: false })
          this.props.onAddSnack('An error ocurred while revoking calendar access.')
        }),
      )
  }
  render() {
    return (
      <Box component="span">
        <DangerButton
          variant="text"
          onClick={() => this.setState({ open: true })}
          startIcon={<FontAwesomeIcon icon={faTrashAlt} />}
        >
          Disconnect
        </DangerButton>
        <NonDismissibleDialog
          open={this.state.open}
          headerText="Confirm Calendar Sync Removal"
          onClose={() => this.setState({ open: false })}
        >
          <NonDismissibleDialog.Body>
            <Typography paragraph>Are you sure you want to remove this calendar integration?</Typography>
            <Typography gutterBottom>This action will:</Typography>
            <ul>
              <Typography component="li">
                Remove all previously synced Scoir events from your external calendar.
              </Typography>
              <Typography component="li">Remove the external calendar events from your Scoir calendar.</Typography>
              <Typography component="li">
                Discontinue the syncing of new Scoir events with your external calendar.
              </Typography>
            </ul>
            {this.state.loading && (
              <Alert
                severity="info"
                icon={<FontAwesomeIcon icon={faClock} />}
              >
                Disconnecting your calendar integration. This may take a few minutes.
              </Alert>
            )}
          </NonDismissibleDialog.Body>
          <NonDismissibleDialog.Footer>
            <NonDismissibleDialog.Footer.CloseButton disabled={this.state.loading}>
              Cancel
            </NonDismissibleDialog.Footer.CloseButton>
            <NonDismissibleDialog.Footer.PrimaryActionButton
              onClick={() => this.disconnect()}
              disabled={this.state.loading}
              startIcon={
                this.state.loading ? (
                  <CircularProgress
                    color="inherit"
                    size={20}
                  />
                ) : null
              }
            >
              Confirm
            </NonDismissibleDialog.Footer.PrimaryActionButton>
          </NonDismissibleDialog.Footer>
        </NonDismissibleDialog>
      </Box>
    )
  }
}

export default connect(null, {
  fetchUser: userActions.fetchUser,
  onAddSnack: snactions.addSnackbarItem,
})(Disconnect)
